import { useContext } from 'react';
import { HeaderContextState } from './HeaderSizeContext';

export const useHeaderSizeContext = () => useContext(HeaderContextState);
